import React, { useEffect, useRef } from 'react';
import { RefreshCw } from 'lucide-react';
import Button from 'v3/components/Button';
import { formatDate } from './contract';
import ListPagination from './ListPagination';
import ResizableTable from './ResizableTable';

export default function StageList({
  definition,
  columns,
  context,
  queryState,
  onPageChange,
  onPerPageChange,
  onRefresh,
  tabs,
  renderRowDetails,
}) {
  const heading = useRef(null);
  useEffect(() => {
    heading.current?.focus({ preventScroll: true });
  }, []);
  const { groups, loading, error } = queryState;
  const group = groups?.[definition.code];
  const page = context.query.pages[definition.code];
  const headingId =
    definition.code === 'AVAILABLE'
      ? 'tc-k-load-list-title'
      : `tc-k-${definition.code.toLowerCase()}-list-title`;
  return (
    <section
      className={definition.className}
      aria-labelledby={headingId}
      data-list-group={definition.code}
      aria-busy={loading}
    >
      {/* 5665: o título fica só para leitores de tela; as abas indicam a lista aberta. */}
      <h1 id={headingId} ref={heading} tabIndex={-1} className="visually-hidden">
        {definition.title}
      </h1>
      <header className="tc-k-list-bar">
        {tabs}
        <Button size="sm" variant="secondary" disabled={loading} onClick={onRefresh}>
          <RefreshCw size={15} aria-hidden="true" /> Atualizar lista
        </Button>
      </header>
      {loading && (
        <p className="tc-k-empty" role="status">
          Carregando {definition.loadingLabel}…
        </p>
      )}
      {error && (
        <div className="tc-k-error" role="alert">
          <span>{error}</span>
          <Button size="sm" onClick={onRefresh}>
            Tentar novamente
          </Button>
        </div>
      )}
      <ResizableTable
        columns={columns}
        rows={group?.data || []}
        rowKey={(row) => row.key}
        offset={(page - 1) * context.query.perPage}
        label={definition.tableLabel}
        renderRowDetails={renderRowDetails}
      />
      {group && !loading && !error && (
        <>
          {group.data.length === 0 && (
            <p className="tc-k-empty" role="status">
              {group.totalCount ? 'Nenhum registro nesta página.' : definition.emptyMessage}
            </p>
          )}
          <ListPagination
            page={page}
            totalPages={group.pagination.totalPages}
            perPage={context.query.perPage}
            summary={`${group.data.length} de ${group.totalCount} registros · Consulta: ${formatDate(group.asOf)}`}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
          />
        </>
      )}
    </section>
  );
}
